














import Vue from 'vue';

export default Vue.extend({
    name: 'QuantityInput',
    props: {
        value: {
            type: Number,
            default: 1
        },
        min: {
            type: Number,
            required: false,
            default: 1
        },
        max: {
            type: Number,
            required: true,
            default: 1
        },
        step: {
            type: Number,
            required: false,
            default: 1
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        updateValue(value: number) {
            if (this.disabled) {
                return;
            }
            if (value && !isNaN(value)) {
                if (value !== this.value) {
                    const sanitized = this.sanitize(value);
                    this.$emit('input', sanitized);
                    if (sanitized !== value) {
                        this.$forceUpdate();
                    }
                }
            }
        },
        sanitize(value: number): number {
            let sanitized: number = value;
            if (this.step > 1) {
                const remainder = value % this.step;
                if (remainder > 0) {
                    sanitized -= remainder;
                }
            }
            if (value < this.min) {
                sanitized = this.min;
            } else if (value > this.max) {
                sanitized = this.max;
            }
            return sanitized;
        },
        decrease() {
            if (this.disabled) {
                return;
            }
            const newValue = parseInt(this.value.toString()) - this.step;
            if (newValue >= this.min) {
                this.updateValue(newValue);
            }
        },
        increase() {
            if (this.disabled) {
                return;
            }
            const newValue = parseInt(this.value.toString()) + this.step;
            if (newValue <= this.max) {
                this.updateValue(newValue);
            }
        }
    }
});
